import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetRankedCryoboxesResponse } from '../../core/api/lab.types';

export const getRankedCryoboxesThunk = createAsyncThunk(
  'shipment/getRankedCryoboxes',
  async (_, { rejectWithValue }: any) => {
    const response: GetRankedCryoboxesResponse = await labApi.getRankedCryoboxes();
    if (response.data?.getRankedCryoboxes) {
      return response.data.getRankedCryoboxes;
    }

    return rejectWithValue(response.errors);
  },
);
